import React from "react";
import { destination } from "../Constant/Index";
import { Link } from "react-router-dom";

const SolvedSection = ({ getapi }) => {
  return (
    <section className="solved-sec pt-5 pb-5 mt-5 mb-4">
      <div className="container">
        <div className="row">
          <div className="col-lg-7 mx-auto">
            <h2 className="main-heading-font dark-color level-2 text-center wow animate__animated animate__zoomIn">
              {/* Solve real problems */}
              {getapi?.sectionTwo?.heading}
            </h2>
            <div className="text-center pb-4">
              <p className="primary-regular-font extra-color-5 level-7">
                {getapi?.sectionTwo?.note}
              </p>
            </div>
          </div>
        </div>
        <div className="solve-detail-img extra-bg-8 radius-20 p-5">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="solved-heading">
                <h5 className="extra-color-5 primary-medium-font level-6">
                  {getapi?.sectionTwo?.note}
                </h5>
                <h6 className="extra-color-6 primary-regular-font mb-3 mt-2 level-7">
                  {/* Thomas Andrew, CEO and founder at MMF */}
                  {getapi?.sectionTwo?.message_by}
                </h6>
                <Link
                  to="/about-us"
                  className="btn log-in level-7 primary-regular-font text-decoration-none"
                >
                  <span className="bg-wrapper">Read more</span>
                </Link>
              </div>
            </div>
            <div className="col-lg-6">
              <figure>
                <img src={getapi?.sectionTwo?.image} className="img-fluid" alt="" />
              </figure>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolvedSection;
